import * as Yup from "yup";

const phoneValidationSchema = Yup.object().shape({
  phone: Yup.string()
    .required("شماره همراه را وارد نمایید")
    .matches(/09[0-9]{9}/, "شماره همراه وارد شده نامعتبر است"),
});

const relationValidationSchema = Yup.object().shape({
  phone: Yup.string()
    .required("شماره همراه را وارد نمایید")
    .matches(/09[0-9]{9}/, "شماره همراه وارد شده نامعتبر است"),
});

const generalInfoValidationSchema = Yup.object().shape({
  bloodType: Yup.string().required("گروه خونی را وارد نمایید"),
});

const personalInfoValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required("نام را وارد نمایید")
    .min(2, "نام باید حداقل 2 کاراکتر باشد")
    .max(50, "نام باید حداکثر 50 کاراکتر باشد"),
  university: Yup.string()
    .required("نام دانشگاه را وارد نمایید")
    .min(2, "نام دانشگاه باید حداقل 2 کاراکتر باشد")
    .max(50, "نام دانشگاه باید حداکثر 50 کاراکتر باشد"),
  universityYear: Yup.number()
    .required("سال دانشگاه را وارد نمایید")
    .min(1350, "سال دانشگاه نامعتبر است")
    .max(1420, "سال دانشگاه نامعتبر است"),
  field: Yup.string().required("رشته تحصیلی را وارد نمایید"),
  fatherName: Yup.string()
    .required("نام پدر را وارد نمایید")
    .min(2, "نام پدر باید حداقل 2 کاراکتر باشد")
    .max(50, "نام پدر باید حداکثر 50 کاراکتر باشد"),
  nid: Yup.string()
    .required("کد ملی را وارد نمایید")
    .min(10, "کد ملی وارد شده نامعتبر است")
    .max(10, "کد ملی وارد شده نامعتبر است")
    .test(
      "is-valid-iran-national-id",
      "کد ملی وارد شده نامعتبر است",
      function (value) {
        if (!value) return false;

        // کدهای ملی شامل ۱۰ رقم تکراری نامعتبرند
        if (/^(.)\1{9}$/.test(value)) return false;

        const check = parseInt(value[9]);
        const sum =
          value
            .split("")
            .slice(0, 9)
            .reduce((acc, cur, i) => acc + parseInt(cur) * (10 - i), 0) % 11;

        return (sum < 2 && check === sum) || (sum >= 2 && check === 11 - sum);
      },
    ),
  birthDay: Yup.string().required("تاریخ تولد را وارد نمایید"),
  password: Yup.string()
    .required("رمزعبور را وارد نمایید")
    .min(6, "رمزعبور باید حداقل 6 کاراکتر باشد")
    .max(50, "رمزعبور باید حداکثر 50 کاراکتر باشد"),
  passwordRepeat: Yup.string().required("تکرار رمزعبور را وارد نمایید"),
});

const relationInfoValidationSchema = Yup.object().shape({
  nearbyName: Yup.string()
    .min(2, "نام فرد باید حداقل 2 کاراکتر باشد")
    .max(50, "نام فرد باید حداکثر 50 کاراکتر باشد"),
  nearbyRel: Yup.string()
    .min(2, "نسبت فرد باید حداقل 2 کاراکتر باشد")
    .max(50, "نسبت فرد باید حداکثر 50 کاراکتر باشد"),
  nearbyPhone: Yup.string()
    .required("شماره همراه فرد مذکور مورد نظر خود را وارد نمایید")
    .matches(/09[0-9]{9}/, "شماره همراه فرد مذکور نامعتبر است"),
});

export {
  phoneValidationSchema,
  generalInfoValidationSchema,
  personalInfoValidationSchema,
  relationValidationSchema,
  relationInfoValidationSchema,
};
